import React from "react";
import { router } from "dva";
import { About } from "./about";
import { BackTopBox } from "./backTopBox";
export { About, BackTopBox };

export const routes = ({ match }) => <router.Route path={`${match.path}`} component={About.Page} />;
